const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* FH 03-11-2026: espaciado de los desplegables de detalle de los muebles.
   - En "Paquete": una línea en blanco antes de cada Paquete 1, 2, 3... (en todos los idiomas).
   - En todos los desplegables: el resto de líneas juntas, sin líneas vacías sobrantes. */
(function () {
  function meaningful(nodes) {
    return [].filter.call(nodes, function (c) {
      return !(c.nodeType === 3 && !c.textContent.trim());
    });
  }
  function fhTidyDetails() {
    var boxes = document.querySelectorAll('.grid__item__faq .accordion__content');
    boxes.forEach(function (box) {
      /* quitar saltos de línea sobrantes al final de cada párrafo y párrafos vacíos */
      box.querySelectorAll('p').forEach(function (p) {
        var last = p.lastChild;
        while (last && ((last.nodeType === 3 && !last.textContent.trim()) || last.nodeName === 'BR')) {
          var prev = last.previousSibling;
          p.removeChild(last);
          last = prev;
        }
        if (!p.textContent.trim() && !p.querySelector('img')) {
          p.style.display = 'none';
        }
      });
    });
    /* línea en blanco solo entre paquetes */
    document.querySelectorAll('[id^="CollapsibleAccordion-collapsible_row_7Ykbbb"] p').forEach(function (p) {
      var nodes = meaningful(p.childNodes);
      var isTitle = nodes.length === 1 && (nodes[0].nodeName === 'STRONG' || nodes[0].nodeName === 'B') && /\d+\s*$/.test(p.textContent.trim());
      var prev = p.previousElementSibling;
      while (prev && prev.style && prev.style.display === 'none') { prev = prev.previousElementSibling; }
      if (isTitle && prev) {
        p.style.setProperty('margin-top', '20px', 'important');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fhTidyDetails);
  } else {
    fhTidyDetails();
  }
})();
